import React from "react";
import SearchIcon from "../../assets/icons/search.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";

export default function ContactSetSearch({
  search,
  setSearch,
  csType,
  setCsType,
  orderBy,
  setOrderBy,
}) {
  return (
    <>
      <div className="">
        <label className="form-label text-nowrap fw-bold text-white p-2">
          Order by:
        </label>
        <Input
          // label="Order by"
          value={[orderBy]}
          onChange={(v) => setOrderBy(v[0])}
          inputType="select"
          isValidNewOption={() => false}
          options={[
            { value: "edited", label: "Last edited" },
            { value: "created", label: "Last created" },
          ]}
        />
      </div>
      <div className="">
        <label className="form-label text-nowrap fw-bold text-white p-2">
          Group type:
        </label>
        <Input
          // label="Group type"
          value={[csType]}
          onChange={(v) => setCsType(v[0])}
          inputType="select"
          isValidNewOption={() => false}
          options={[
            { value: "", label: "All" },
            { value: "dynamic", label: "Dynamic" },
            { value: "static", label: "Static" },
          ]}
        />
      </div>
      <div className="">
        <div className="position-relative">
          <input
            placeholder="Search for a group"
            className="form-control"
            style={{ minWidth: 400, height: 40 }}
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <SearchIcon
            width={30}
            heigth={30}
            className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
            style={{ marginRight: -10 }}
          />
        </div>
      </div>
    </>
  );
}
